/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useState, useEffect} from "react";
import "./Header.scss";
import {
  LogOut as LogOutIcon,
  MessageCircle as MessageCircleIcon,
  Settings as SettingsIcon,
  CreditCard as CreditCardIcon,
} from "react-feather";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Image from "react-bootstrap/Image";
import Dropdown from "react-bootstrap/Dropdown";
import {User as UserIcon} from "react-feather";
import logo from "@images/logo.png";
import Button from "@adoo-ui/Atom/Button";
import Container from "react-bootstrap/Container";
import {CurrentUserObjectType} from "@types";
import {MouseEvent} from "react";
import * as analytics from "@helpers/ga4";

interface IHeaderProps {
  isAuthenticated: boolean;
  routeCodes: {[key: string]: string};
  setIsLoginFormVisible: (value: boolean) => void;
  logout: () => void;
  currentUser: CurrentUserObjectType;
  isDiarioOficialRoute: boolean;
  isConsultaProcessual: boolean;
}

function Header({
  isAuthenticated,
  routeCodes,
  setIsLoginFormVisible,
  logout,
  currentUser,
  isDiarioOficialRoute,
  isConsultaProcessual,
}: IHeaderProps) {
  const [width, setWidth] = useState(window.innerWidth);
  const [isMobileMenuVisible, setIsMobileMenuVisible] = useState(false);

  function handleWindowSizeChange() {
    setWidth(window.innerWidth);
  }
  useEffect(() => {
    window.addEventListener("resize", handleWindowSizeChange);
    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, []);

  const isMedium = width <= 992;

  return (
    <header className="header-area header-sticky">
      <Container fluid>
        <Row>
          <Col>
            <nav className="main-nav">
              <a href="/" title="Logo" className="logo">
                <img src={logo} alt="Adoo" width="150" />
              </a>
              {isMobileMenuVisible || !isMedium ? (
                <ul className="nav">
                  {!isAuthenticated && isMedium ? (
                    <li
                      onClick={() => {
                        setIsLoginFormVisible(true);
                        setIsMobileMenuVisible(!isMobileMenuVisible);
                      }}
                    >
                      <a className="login-mobile-link" href="#">
                        <UserIcon size={22} className="login-mobile-link-icon" /> Faça
                        Login
                      </a>
                    </li>
                  ) : isMedium ? (
                    <>
                      <li>
                        <a
                          className="login-mobile-link"
                          href={routeCodes.GERAL_EDITAR_PERFIL}
                        >
                          <Image
                            src={currentUser?.user?.linkImagem}
                            roundedCircle
                            thumbnail={true}
                            style={{width: 35, marginTop: 0}}
                          />
                          <span style={{paddingLeft: 10}}>{currentUser?.user?.nome}</span>
                        </a>
                      </li>
                      <li onClick={() => setIsMobileMenuVisible(!isMobileMenuVisible)}>
                        <a href={routeCodes.PLANOS_PRINCIPAL} className="menu-item">
                          Planos
                        </a>
                      </li>
                    </>
                  ) : null}
                  <li
                    className="scroll-to-section"
                    onClick={() => setIsMobileMenuVisible(!isMobileMenuVisible)}
                  >
                    <a href="/#inicio" className="menu-item">
                      Início
                    </a>
                  </li>
                  <li
                    className=""
                    onClick={() => setIsMobileMenuVisible(!isMobileMenuVisible)}
                  >
                    <a
                      className={isDiarioOficialRoute ? "menu-diario-active" : ""}
                      href="/navegacao"
                    >
                      Diários Oficiais
                    </a>
                  </li>
                  {/* <li
                    className=""
                    onClick={() => setIsMobileMenuVisible(!isMobileMenuVisible)}
                  >
                    <a
                      className={isConsultaProcessual ? "menu-diario-active" : ""}
                      href="/consulta-processual"
                    >
                      Consulta Processual
                    </a>
                  </li> */}
                  <li
                    className="scroll-to-section"
                    onClick={() => setIsMobileMenuVisible(!isMobileMenuVisible)}
                  >
                    <a
                      href="/#contato"
                      className="menu-item"
                      onClick={() => analytics.actionTrack("Clique no menu contato")}
                    >
                      Contato
                    </a>
                  </li>
                  <li onClick={() => setIsMobileMenuVisible(!isMobileMenuVisible)}>
                    <a href="https://devs.adoo.com.br/" target="_blank" rel="noreferrer">
                      APIs
                    </a>
                  </li>
                  {isMedium && isAuthenticated ? (
                    <li
                      className="scroll-to-section"
                      onClick={() => setIsMobileMenuVisible(!isMobileMenuVisible)}
                    >
                      <a href="/" style={{paddingLeft: 10}} onClick={logout}>
                        Sair
                      </a>
                    </li>
                  ) : null}
                </ul>
              ) : null}
              <a
                className={`menu-trigger ${isMobileMenuVisible ? "active" : ""}`}
                onClick={() => setIsMobileMenuVisible(!isMobileMenuVisible)}
              >
                <span>Menu</span>
              </a>
            </nav>
          </Col>
          <Col lg={1} className="login-corner-wrp">
            {isAuthenticated ? (
              <Dropdown className="large-only">
                <Dropdown.Toggle id="tog" style={{border: "none", background: "none"}}>
                  <Image
                    id="tog2"
                    src={currentUser.user?.linkImagem}
                    roundedCircle
                    thumbnail={true}
                    style={{width: 60, marginTop: 3}}
                  />
                </Dropdown.Toggle>

                <Dropdown.Menu id="tog3" className="user-menu-dropdown">
                  <Dropdown.Item href={routeCodes.PLANOS_PRINCIPAL}>
                    <CreditCardIcon size={15} /> Assinaturas
                  </Dropdown.Item>
                  <Dropdown.Divider />
                  <Dropdown.Item href={routeCodes.GERAL_EDITAR_PERFIL}>
                    <SettingsIcon size={15} /> Configurações da conta
                  </Dropdown.Item>
                  <Dropdown.Divider />
                  <Dropdown.Item href={routeCodes.SUPORTE_AJUDA}>
                    <MessageCircleIcon size={15} /> Suporte
                  </Dropdown.Item>
                  <Dropdown.Divider />
                  <Dropdown.Item href="/" onClick={logout}>
                    <LogOutIcon size={15} /> Sair
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            ) : (
              <Button
                id="entrar-button"
                className="adoo-btn--lg btn-entrar"
                onClick={(e: MouseEvent) => setIsLoginFormVisible(!isAuthenticated)}
              >
                Entrar
              </Button>
            )}
          </Col>
        </Row>
      </Container>
    </header>
  );
}

export default Header;
